import * as CartCustomOptionsSelectionsActions from "./cart-custom-options-selections.actions";
import * as _ from "lodash";

export interface State {
  cartCustomOptionsSelections: any[];
}

const initialState: State = {
  cartCustomOptionsSelections: [],
};

export function cartCustomOptionsSelectionsReducer(
  state = initialState,
  action: CartCustomOptionsSelectionsActions.CartCustomOptionsSelectionsActions
) {
  switch (action.type) {
    case CartCustomOptionsSelectionsActions.ADD_UPDATE_CUSTOM_OPTION_SELECTION:
      const cartCustomOptionsSelections =
        state.cartCustomOptionsSelections || [];
      const key = _.findIndex(cartCustomOptionsSelections, (option) => {
        if (option && option.preNameId && action.payload.preNameId) {
          return option.preNameId === action.payload.preNameId;
        } else {
          return option.timestamp === action.payload.timestamp;
        }
      });
      if (key !== -1) {
        const updateOption = {
          ...cartCustomOptionsSelections[key],
          ...action.payload,
        };
        const updatedCartCustomOptions = [...cartCustomOptionsSelections];
        updatedCartCustomOptions[key] = updateOption;
        return {
          ...state,
          cartCustomOptionsSelections: updatedCartCustomOptions,
        };
      } else {
        if (!cartCustomOptionsSelections.length) {
          return {
            ...state,
            cartCustomOptionsSelections: [action.payload],
          };
        } else {
          return {
            ...state,
            cartCustomOptionsSelections: [
              ...cartCustomOptionsSelections,
              action.payload,
            ],
          };
        }
      }

    case CartCustomOptionsSelectionsActions.CLEAR_CART_CUSTOM_OPTIONS_SELECTIONS:
      return {
        ...state,
        cartCustomOptionsSelections: [],
      };

    default:
      return state;
  }
}
